import React from 'react';
import dayjs from 'dayjs';

// Shared styles used across all print layouts
export const printStyles = {
  page: {
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: '10pt',
    color: '#000',
    backgroundColor: '#fff',
    padding: '0',
    lineHeight: 1.4,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingBottom: '10pt',
    borderBottom: '2pt solid #1677ff',
    marginBottom: '14pt',
  },
  logo: { fontSize: '18pt', fontWeight: 'bold', color: '#1677ff', margin: 0 },
  logoSub: { fontSize: '9pt', color: '#666', margin: '2pt 0 0 0' },
  dateBlock: { textAlign: 'right' },
  dateLabel: { fontSize: '8pt', color: '#888', margin: 0 },
  dateValue: { fontSize: '10pt', fontWeight: 'bold', margin: '2pt 0 0 0' },
  title: { fontSize: '14pt', fontWeight: 'bold', margin: '0 0 3pt 0' },
  subtitle: { fontSize: '10pt', color: '#555', margin: '0 0 10pt 0' },
  infoBar: {
    display: 'flex', flexWrap: 'wrap', gap: '6pt',
    backgroundColor: '#f5f5f5', padding: '5pt 8pt',
    borderRadius: '3pt', marginBottom: '12pt', fontSize: '8pt',
  },
  infoChip: {
    backgroundColor: '#fff', border: '1pt solid #ccc',
    borderRadius: '2pt', padding: '1pt 6pt',
  },
  sectionTitle: {
    fontSize: '11pt', fontWeight: 'bold',
    borderBottom: '1pt solid #333',
    paddingBottom: '3pt', marginTop: '14pt', marginBottom: '7pt',
  },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: '9pt' },
  th: {
    backgroundColor: '#f0f0f0', border: '1pt solid #d0d0d0',
    padding: '4pt 7pt', textAlign: 'left', fontWeight: 'bold', fontSize: '8.5pt',
  },
  td: { border: '1pt solid #d0d0d0', padding: '3pt 7pt', verticalAlign: 'top' },
  tdRight: { border: '1pt solid #d0d0d0', padding: '3pt 7pt', textAlign: 'right', verticalAlign: 'top' },
  tdCenter: { border: '1pt solid #d0d0d0', padding: '3pt 7pt', textAlign: 'center', verticalAlign: 'top' },
  trEntrada: { backgroundColor: '#f6ffed' },
  trSalida: { backgroundColor: '#fff1f0' },
  trSummary: { backgroundColor: '#fafafa', fontWeight: 'bold' },
  kpiGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '8pt', marginBottom: '14pt',
  },
  kpiCard: {
    border: '1pt solid #d0d0d0', borderRadius: '5pt',
    padding: '9pt 11pt', textAlign: 'center',
  },
  kpiLabel: { fontSize: '8pt', color: '#888', marginBottom: '3pt' },
  kpiValue: { fontSize: '16pt', fontWeight: 'bold' },
  summaryGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '8pt', margin: '10pt 0 14pt 0',
  },
  summaryCard: {
    border: '1pt solid #d0d0d0', borderRadius: '4pt',
    padding: '7pt', textAlign: 'center',
  },
  summaryLabel: { fontSize: '7.5pt', color: '#888', margin: '0 0 2pt 0' },
  summaryValue: { fontSize: '13pt', fontWeight: 'bold', margin: 0 },
  footer: {
    marginTop: '14pt', paddingTop: '6pt', borderTop: '1pt solid #ccc',
    fontSize: '7.5pt', color: '#888', display: 'flex', justifyContent: 'space-between',
  },
};

export function PrintPageHeader({ titulo, subtitulo, infoRows = [] }) {
  return (
    <>
      <div style={printStyles.header}>
        <div>
          <p style={printStyles.logo}>&#128230; RADTRANS.</p>
          <p style={printStyles.logoSub}>Sistema de Gestión de Inventario</p>
        </div>
        <div style={printStyles.dateBlock}>
          <p style={printStyles.dateLabel}>Fecha de impresión</p>
          <p style={printStyles.dateValue}>{dayjs().format('DD/MM/YYYY HH:mm:ss')}</p>
        </div>
      </div>
      <h2 style={printStyles.title}>{titulo}</h2>
      {subtitulo && <p style={printStyles.subtitle}>{subtitulo}</p>}
      {infoRows.length > 0 && (
        <div style={printStyles.infoBar}>
          {infoRows.map((r, i) => (
            <span key={i} style={printStyles.infoChip}>
              <strong>{r.label}:</strong> {r.value}
            </span>
          ))}
        </div>
      )}
    </>
  );
}

export function PrintFooter() {
  return (
    <div style={printStyles.footer}>
      <span>Sistema de Gestión de Inventario</span>
      <span>Generado: {dayjs().format('DD/MM/YYYY HH:mm:ss')}</span>
    </div>
  );
}
